module.exports = __webpack_public_path__ + "static/media/whatsapp_bg.35553f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp_bg.png
// module id = 39
// module chunks = 0